import { IPlannedPortfolio } from '../../models/plannedPortfolios';
import { EntityState } from '@ngrx/entity';
import {  } from '../planned-portfolios/selectors/planned-portfolios.selectors';
import { tempPlannedPortfolioAdapter } from '../planned-portfolios/selectors/temp-planned-portfolios.selectors';

export interface ITempPlannedPortfoliosState extends EntityState<IPlannedPortfolio> {
    selectedSubscriptionId: number | null;
    loading: boolean;
}
export const initialTempPlannedPortfoliosState: ITempPlannedPortfoliosState =  tempPlannedPortfolioAdapter.getInitialState({
    selectedSubscriptionId: null,
    loading: false
});
